import { makeAutoObservable, runInAction } from 'mobx';
import { GetUnreadNotificationCountAsync } from '../services/notification';

export class NotificationStore {
  unreadCount = 0;
  loading = false;

  constructor() {
    makeAutoObservable(this);
  }

  fetchUnreadCount = async () => {
    try {
      this.loading = true;
      const count = await GetUnreadNotificationCountAsync();
      runInAction(() => {
        this.unreadCount = count || 0;
        this.loading = false;
      });
    } catch (error) {
      console.error('Failed to fetch unread notification count', error);
      runInAction(() => {
        this.loading = false;
      });
    }
  };

}

export const notificationStore = new NotificationStore();
